// extracted by mini-css-extract-plugin
export default {"layout":"DashboardLayout_layout__iQoJY"};